
export const config = {
    trackingId: 'G-PP097V6BX5'
  }